import { render } from "./PackagesManagerItemsList.vue?vue&type=template&id=ef9e9508&scoped=true"
import script from "./PackagesManagerItemsList.vue?vue&type=script&lang=js"
export * from "./PackagesManagerItemsList.vue?vue&type=script&lang=js"

import "./PackagesManagerItemsList.vue?vue&type=style&index=0&id=ef9e9508&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef9e9508"]])

export default __exports__